import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/y42-product-logos`;

export const datasourceTableIcon: SvgIcon = `${iconsBasePath}/table.svg`;
export const datasourceTableStrokedIcon: SvgIcon = `${iconsBasePath}/table-stroked.svg`;
export const exportTriggerIcon: SvgIcon = `${iconsBasePath}/trigger.svg`;
export const visualizationDashboardTabIcon: SvgIcon = `${iconsBasePath}/dashboard-tab.svg`;
export const templateIcon: SvgIcon = `${iconsBasePath}/template.svg`;
export const dataTestIcon: SvgIcon = `${iconsBasePath}/data-test.svg`;
export const dataTestStrokedIcon: SvgIcon = `${iconsBasePath}/data-test-stroked.svg`;
export const dataContractIcon: SvgIcon = `${iconsBasePath}/data-contract.svg`;
export const integrationIcon: SvgIcon = `${iconsBasePath}/integration.svg`;
export const integrationStrokeIcon: SvgIcon = `${iconsBasePath}/integration-stroked.svg`;
export const modelIcon: SvgIcon = `${iconsBasePath}/model.svg`;
export const modelStrokeIcon: SvgIcon = `${iconsBasePath}/model-stroked.svg`;
export const uiModelIcon: SvgIcon = `${iconsBasePath}/model-ui.svg`;
export const uiModelStrokeIcon: SvgIcon = `${iconsBasePath}/model-ui-stroked.svg`;
export const sqlModelIcon: SvgIcon = `${iconsBasePath}/model-sql.svg`;
export const sqlModelStrokeIcon: SvgIcon = `${iconsBasePath}/model-sql-stroked.svg`;
export const orchestrationIcon: SvgIcon = `${iconsBasePath}/orchestration.svg`;
export const orchestrationStrokeIcon: SvgIcon = `${iconsBasePath}/orchestration-stroked.svg`;
export const visualizationDashboardIcon: SvgIcon = `${iconsBasePath}/dashboard.svg`;
export const visualizationDashboardStrokeIcon: SvgIcon = `${iconsBasePath}/dashboard-stroked.svg`;
export const visualizationWidgetIcon: SvgIcon = `${iconsBasePath}/widget.svg`;
export const visualizationWidgetsIcon: SvgIcon = `${iconsBasePath}/widgets.svg`;
export const visualizationWidgetStrokeIcon: SvgIcon = `${iconsBasePath}/widget-stroked.svg`;
export const visualizationIcon: SvgIcon = `${iconsBasePath}/visualisation.svg`;
export const visualizationStrokeIcon: SvgIcon = `${iconsBasePath}/visualisation-stroked.svg`;
export const exportIcon: SvgIcon = `${iconsBasePath}/data-export.svg`;
export const exportStrokeIcon: SvgIcon = `${iconsBasePath}/data-export-stroked.svg`;
export const alertIcon: SvgIcon = `${iconsBasePath}/alert.svg`;
export const alertStrokeIcon: SvgIcon = `${iconsBasePath}/alert-stroked.svg`;
export const dataLineageIcon: SvgIcon = `${iconsBasePath}/data-lineage.svg`;
export const dataLineageStrokeIcon: SvgIcon = `${iconsBasePath}/data-lineage-stroked.svg`;
export const dataCatalogIcon: SvgIcon = `${iconsBasePath}/data-catalog.svg`;
export const dataCatalogStrokeIcon: SvgIcon = `${iconsBasePath}/data-catalog-stroked.svg`;
export const connectionsStrokeIcon: SvgIcon = `${iconsBasePath}/y42-connections-stroke.svg`;
export const developIcon: SvgIcon = `${iconsBasePath}/develop.svg`;
